import { type AddPriceTrackRequest } from '@clients/PricetrackApi';

export interface PriceTrackInfo extends AddPriceTrackRequest {
    arrivalDateTime?: Date;
    departureDateTime?: Date;
    logoUrl: string;
    dateString: string | null;
    priceTrackOnPath: boolean;
}

export type TrackScope = 'ticket' | 'path';

export enum PriceTrackType {
    Capacity = 0,
    Price = 1,
    Promote = 2,
    PreSell = 3,
}
